import { GlobalContext } from '../../../../../../../utils/globalprovider';

import React from 'react';
import './speaker-menu.css';
import { orderBy } from 'lodash';


class SpeakerMenu extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.onWheel = this.onWheel.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onCloseMenu = this.onCloseMenu.bind(this);
    this.listRef = React.createRef();

    this.state = {
      searchText: '',
      highlightedIndex: -1,
    };
  }

  // ***************************************************************************************
  // onCloseMenu()
  // Ferme le menu de sélection du speaker
  // ***************************************************************************************
  onCloseMenu() {
     this.setState({
      searchText: '',
      highlightedIndex: -1,
    })
    
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  // ***************************************************************************************
  // onSearchChange()
  // Appelé quand le texte de recherche change
  // ***************************************************************************************
  onSearchChange(event) {
    this.setState({
      searchText: event.target.value,
      highlightedIndex: -1,
    });
  }

  // ***************************************************************************************
  // scrollToHighlighted()
  // Scroll l'élément en surbrillance dans la vue
  // ***************************************************************************************
  scrollToHighlighted() {
    if (this.listRef.current && this.state.highlightedIndex >= 0) {
      const items = this.listRef.current.querySelectorAll('.speaker-menu-item');
      const highlightedItem = items[this.state.highlightedIndex];

      if (highlightedItem) {
        highlightedItem.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.highlightedIndex !== this.state.highlightedIndex) {
      this.scrollToHighlighted();
    }
  }

  onKeyDown(event) {
    const { key } = event;

    // Obtenir les speakers filtrés
    let speakers = orderBy(this.props.speakers, (x) => x.name);
    if (this.state.searchText) {
      const searchLower = this.state.searchText.toLowerCase();
      speakers = speakers.filter((speaker) =>
        speaker.name.toLowerCase().includes(searchLower)
      );
    }

    switch (key) {
      case 'ArrowDown':
        event.preventDefault();
        event.stopPropagation();
        this.setState((prevState) => ({
          highlightedIndex: Math.min(
            prevState.highlightedIndex + 1,
            speakers.length - 1
          ),
        }));
        break;

      case 'ArrowUp':
        event.preventDefault();
        event.stopPropagation();
        this.setState((prevState) => ({
          highlightedIndex: Math.max(prevState.highlightedIndex - 1, -1),
        }));
        break;

      case 'Enter':
        event.preventDefault();
        event.stopPropagation();
        if (
          this.state.highlightedIndex >= 0 &&
          speakers[this.state.highlightedIndex]
        ) {
          this.onSelectSpeaker(speakers[this.state.highlightedIndex].id);
        }
        break;

      case 'Escape':
        event.preventDefault();
        event.stopPropagation();
        this.props.onClose();
        break;

      default:
        // Laisser passer les touches de texte
        if (key.length === 1 || key === 'Backspace' || key === 'Delete') {
          event.stopPropagation();
        } else {
          event.preventDefault();
          event.stopPropagation();
        }
    }
  }

  // ***************************************************************************************
  // onSelectSpeaker()
  // Appelé quand l'utilisateur sélectionne un speaker
  // ***************************************************************************************
  onSelectSpeaker(speakerId) {
    this.onCloseMenu();

    if (this.props.onSelectSpeaker) {
      this.props.onSelectSpeaker(speakerId);
    }
  }

  // ***************************************************************************************
  // onWheel()
  // Appelé quand on scroll dans le menu avec la molette
  // ***************************************************************************************
  onWheel(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    if (!this.props.speakerMenu.display || !this.props.speakers.length) {
      return <></>;
    }

    let speakers = orderBy(this.props.speakers, (x) => x.name);

    // Filtrer les speakers en fonction du texte de recherche
    if (this.state.searchText) {
      const searchLower = this.state.searchText.toLowerCase();
      speakers = speakers.filter((speaker) =>
        speaker.name.toLowerCase().includes(searchLower)
      );
    }

    const lang = this.context.language;

    return (
      <div className="speaker-menu-overlay" onClick={this.onCloseMenu}>
        <div
          className="speaker-menu"
          style={{
            left: `${this.props.speakerMenu.x}px`,
            top: `${this.props.speakerMenu.y}px`,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <p className="speaker-menu-title">
            {lang === 'fr'
              ? 'Sélectionner un speaker'
              : 'Select a speaker'}
          </p>
          <label htmlFor="txtSearchSpeaker" className="sr-only">
            {lang === 'fr'
              ? 'Rechercher un speaker'
              : 'Search a speaker'}
          </label>
          <input
            id="txtSearchSpeaker"
            type="text"
            className="speaker-menu-search"
            placeholder={
              lang === 'fr' ? 'Rechercher...' : 'Search...'
            }
            value={this.state.searchText}
            onKeyDown={this.onKeyDown}
            onChange={this.onSearchChange}
            autoFocus
          />
          <div
            className="speaker-menu-list"
            ref={this.listRef}
            onWheel={this.onWheel}
            role="list"
          >
            {speakers.map((speaker, index) => {
              const names = [];

              if (speaker.firstname) {
                names.push(speaker.firstname);
              }

              if (speaker.name) {
                names.push(speaker.name);
              }

              return (
                <div
                  role="listitem"
                  key={speaker.id}
                  className={`speaker-menu-item ${
                    speaker.id === this.props.speakerMenu.speakerId ? 'selected' : ''
                  } ${
                    index === this.state.highlightedIndex ? 'highlighted' : ''
                  }`}
                  onClick={() => this.onSelectSpeaker(speaker.id)}
                >
                  <span className="speaker-name">{names.join(' ')}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default SpeakerMenu;
